
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 0L25 24.732 0 0v13.565L24.769 38.07l.232.228.23-.228L50 13.565z","fill":"#F3F2F1","fill-rule":"evenodd"}})])
          )
        }
      }
    